import axios from "axios";

export default {
    namespaced: true,

    state: {
        newestToponymOfTheMonth: {},
    },

    getters: {
        newestToponymOfTheMonth(state) {
            return state.newestToponymOfTheMonth;
        },
    },

    mutations: {
        SET_NEWEST_TOPONYM_OF_THE_MONTH(state, newestToponymOfTheMonth) {
            state.newestToponymOfTheMonth = newestToponymOfTheMonth;
        },
    },

    actions: {
        async getNewestToponymOfTheMonth({ commit }) {
            await axios
                .get("/api/newest-toponym-of-the-month")
                .then((response) => {
                    commit("SET_NEWEST_TOPONYM_OF_THE_MONTH", response.data);
                });
        },
    },
};
